import { Dispatch, Action } from 'redux'
import { UploadedFilesMainMapDispatchReturnType } from './types/UploadedFilesMainMapDispatchReturnType'

export const UploadedFilesMainMapDispatch = (
  _dispatch: Dispatch<Action>
): UploadedFilesMainMapDispatchReturnType => {
  return {}
}
